import { useLazyQuery } from "@apollo/client";
import { GetBankHolidaysDocument } from "../../gql/generated/graphql";

export const useGetBankHolidays = () => {
  const [getBankHolidays] = useLazyQuery(GetBankHolidaysDocument);

  return {
    getBankHolidays: async (from: Date, to: Date) => {
      const { data } = await getBankHolidays({
        variables: {
          from,
          to,
        },
      });
      if (!data?.getBankHolidays) {
        throw new Error("Failed to get bank holidays");
      }

      return data.getBankHolidays.map(bankHoliday => ({
        name: bankHoliday.name,
        startDate: new Date(bankHoliday.startDate),
        endDate: new Date(bankHoliday.endDate),
        customDelay: bankHoliday.customDelay ?? undefined,
      }));
    },
  };
};
